import Vue from 'vue'
import Vuex from 'vuex'
import base from './modules/base';
import tab from './modules/tab';
import setting from './modules/setting';
import nav from './modules/nav';
import dictionary from './modules/dictionary';
import depart from './modules/depart';
import supGroup from './modules/supGroup';
import category from './modules/category';
import classification from './modules/classification';
import user from './modules/user';

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    base,
    tab,
    setting,
    nav,
    dictionary,
    depart,
    supGroup,
    category,
    classification,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js